







import Vue from 'vue'

export default Vue.extend({
  data() {
    return {}
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    showExitButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  name: 'ModalHeader',
})
